import cx from 'classnames';
import PlanDetails from './PlanDetails';
import styles from './PlanInfoCard.module.scss';
import PlanMainInfoBlock from './PlanMainInfoBlock';
// import PricingCurrentTag from './PricingCurrentTag';
import Loader from '../../components/Loader/Loader';
import ActionLink from './ActionLink';
import { windowOpen } from '../../helpers/jsHelper';
import { LIVE_FURNISH } from '../../constants/projectConstants';
import { useDispatch } from 'react-redux';
// import { setContactFormDialogOpen } from '../../redux/slicers/subscriptionSlicer';

function PlanInfoCard({
  name,
  description,
  amount = '',
  unit = '',
  fullWidth = false,
  isCurrentPlan = false,
  buttonText = '',
  buttonClick = null,
  style,
  features = [],
  keepPlanDetailsOpen,
  hideActions,
  isFreemium = false,
  allData,
  onClick,
  loading = false,
  designV2 = false,
  recommendedProps = {},
  isCurrentPlanIsFreemium,
  // samePlan,
}) {
  const dispatch = useDispatch();

  const _features = features.filter((a) => !a.is_free_bee);
  const freebiesFeatures = features.filter((a) => a.is_free_bee);

  const isRecommened = recommendedProps?.shouldShow

  return (
    <div
      className={cx(
        styles.planInfoContainer,
        fullWidth ? styles.fullWidth : '',
        designV2 ? styles.designV2 : '',
        designV2 && isRecommened ? styles.recommended : ''
      )}
      style={style}>
      {loading && <Loader position="absolute" loading backdrop />}
      {/* {isCurrentPlan && samePlan && <PricingCurrentTag text="CURRENT PLAN" />} */}
      {isRecommened && <div className={styles.planRecommends}>{recommendedProps?.text}</div>}
      <PlanMainInfoBlock
        title={name}
        description={description}
        amount={amount}
        unit={unit}
        buttonText={buttonText}
        onClick={buttonClick}
        isFreemium={isFreemium}
        allData={allData}
        onSelect={onClick}
        buttonType={(isFreemium || isCurrentPlanIsFreemium) ? 'light' : 'primary'}
        buttonClassName={isCurrentPlan || (isCurrentPlan && isFreemium) ? styles.currentPlan : ''}
        designV2={designV2}
        style={
          designV2
            ? {
                paddingTop: '2.5rem',
                border: 'none',
              }
            : {}
        }
      />
      {_features.length !== 0 && (
        <PlanDetails
          features={_features}
          keepDetailsOpen={keepPlanDetailsOpen}
          titleSectionStyle={{
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
          }}
          designV2={designV2}
        />
      )}
      {freebiesFeatures.length !== 0 && (
        <PlanDetails
          title={
            <>
              Freebies{' '}
              <small>
                <em>(*for first year only)</em>
              </small>
            </>
          }
          features={freebiesFeatures}
          keepDetailsOpen={keepPlanDetailsOpen}
          titleSectionStyle={{
            borderLeft: 'none',
            borderRight: 'none',
          }}
          designV2={designV2}
        />
      )}

      {!hideActions && (
        <div
          className={'d-flex gap-4 flex-wrap'}
          style={{
            padding: '16px 24px',
            background: '#fff',
          }}>
          <ActionLink
            title="Compare Plans"
            onClick={() => windowOpen(LIVE_FURNISH.pricing, '_blank')}
          />
          {/* <ActionLink
            title={`Contact about ${name}`}
            onClick={() => dispatch(setContactFormDialogOpen(true))}
          /> */}
        </div>
      )}
    </div>
  );
}

export default PlanInfoCard;
